import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=64155e0c&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=64155e0c&prod&scoped=true&lang=css"
import style1 from "./AdminDashboard.vue?vue&type=style&index=1&id=64155e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64155e0c",
  null
  
)

export default component.exports